export interface ChartDataPoint {
  Grade: number | string
  "5th %ile": number | null
  "25th %ile": number | null
  Mean: number | null
  "75th %ile": number | null
  "95th %ile": number | null
  [name: string]: number | string | null
}

export const readingData: ChartDataPoint[] = [
  {
    Grade: "K",
    "5th %ile": 110,
    "25th %ile": 126,
    Mean: 138,
    "75th %ile": 148,
    "95th %ile": 165,
  },
  {
    Grade: 0.333333333333333,
    "5th %ile": 128,
    "25th %ile": 141,
    Mean: 150,
    "75th %ile": 158,
    "95th %ile": 172,
  },
  {
    Grade: 0.666666666666667,
    "5th %ile": 136,
    "25th %ile": 149,
    Mean: 158,
    "75th %ile": 166,
    "95th %ile": 179,
  },
  {
    Grade: 1,
    "5th %ile": 139,
    "25th %ile": 152,
    Mean: 161,
    "75th %ile": 170,
    "95th %ile": 182,
  },
  {
    Grade: 1.33333333333333,
    "5th %ile": 149,
    "25th %ile": 162,
    Mean: 172,
    "75th %ile": 181,
    "95th %ile": 194,
  },
  {
    Grade: 1.66666666666667,
    "5th %ile": 154,
    "25th %ile": 168,
    Mean: 178,
    "75th %ile": 187,
    "95th %ile": 201,
  },
  {
    Grade: 2,
    "5th %ile": 149,
    "25th %ile": 164,
    Mean: 175,
    "75th %ile": 185,
    "95th %ile": 200,
  },
  {
    Grade: 2.33333333333333,
    "5th %ile": 160,
    "25th %ile": 174,
    Mean: 184,
    "75th %ile": 194,
    "95th %ile": 209,
  },
  {
    Grade: 2.66666666666667,
    "5th %ile": 164,
    "25th %ile": 178,
    Mean: 189,
    "75th %ile": 199,
    "95th %ile": 214,
  },
  {
    Grade: 3,
    "5th %ile": 162,
    "25th %ile": 178,
    Mean: 188,
    "75th %ile": 199,
    "95th %ile": 214,
  },
  {
    Grade: 3.33333333333333,
    "5th %ile": 171,
    "25th %ile": 185,
    Mean: 196,
    "75th %ile": 206,
    "95th %ile": 221,
  },
  {
    Grade: 3.66666666666667,
    "5th %ile": 174,
    "25th %ile": 188,
    Mean: 199,
    "75th %ile": 209,
    "95th %ile": 223,
  },
  {
    Grade: 4,
    "5th %ile": 173,
    "25th %ile": 188,
    Mean: 198,
    "75th %ile": 209,
    "95th %ile": 224,
  },
  {
    Grade: 4.33333333333333,
    "5th %ile": 179,
    "25th %ile": 194,
    Mean: 204,
    "75th %ile": 214,
    "95th %ile": 228,
  },
  {
    Grade: 4.66666666666667,
    "5th %ile": 181,
    "25th %ile": 196,
    Mean: 206,
    "75th %ile": 216,
    "95th %ile": 230,
  },
  {
    Grade: 5,
    "5th %ile": 181,
    "25th %ile": 195,
    Mean: 206,
    "75th %ile": 216,
    "95th %ile": 231,
  },
  {
    Grade: 5.33333333333333,
    "5th %ile": 186,
    "25th %ile": 200,
    Mean: 210,
    "75th %ile": 220,
    "95th %ile": 234,
  },
  {
    Grade: 5.66666666666667,
    "5th %ile": 188,
    "25th %ile": 202,
    Mean: 212,
    "75th %ile": 222,
    "95th %ile": 236,
  },
  {
    Grade: 6,
    "5th %ile": 186,
    "25th %ile": 201,
    Mean: 211,
    "75th %ile": 221,
    "95th %ile": 236,
  },
  {
    Grade: 6.33333333333333,
    "5th %ile": 190,
    "25th %ile": 204,
    Mean: 214,
    "75th %ile": 224,
    "95th %ile": 238,
  },
  {
    Grade: 6.66666666666666,
    "5th %ile": 192,
    "25th %ile": 206,
    Mean: 216,
    "75th %ile": 226,
    "95th %ile": 240,
  },
  {
    Grade: 7,
    "5th %ile": 189,
    "25th %ile": 204,
    Mean: 214,
    "75th %ile": 225,
    "95th %ile": 240,
  },
  {
    Grade: 7.33333333333333,
    "5th %ile": 192,
    "25th %ile": 207,
    Mean: 217,
    "75th %ile": 227,
    "95th %ile": 242,
  },
  {
    Grade: 7.66666666666666,
    "5th %ile": 193,
    "25th %ile": 208,
    Mean: 218,
    "75th %ile": 228,
    "95th %ile": 243,
  },
  {
    Grade: 8,
    "5th %ile": 191,
    "25th %ile": 207,
    Mean: 217,
    "75th %ile": 228,
    "95th %ile": 246,
  },
  {
    Grade: 8.33333333333333,
    "5th %ile": 194,
    "25th %ile": 209,
    Mean: 219,
    "75th %ile": 229,
    "95th %ile": 244,
  },
  {
    Grade: 8.66666666666666,
    "5th %ile": 194,
    "25th %ile": 209,
    Mean: 220,
    "75th %ile": 231,
    "95th %ile": 246,
  },
  {
    Grade: 9,
    "5th %ile": 194,
    "25th %ile": 210,
    Mean: 220,
    "75th %ile": 231,
    "95th %ile": 246,
  },
  {
    Grade: 9.33333333333333,
    "5th %ile": 196,
    "25th %ile": 211,
    Mean: 221,
    "75th %ile": 232,
    "95th %ile": 247,
  },
  {
    Grade: 9.66666666666667,
    "5th %ile": 195,
    "25th %ile": 211,
    Mean: 222,
    "75th %ile": 233,
    "95th %ile": 249,
  },
  {
    Grade: 10,
    "5th %ile": 193,
    "25th %ile": 209,
    Mean: 220,
    "75th %ile": 232,
    "95th %ile": 248,
  },
  {
    Grade: 10.3333333333333,
    "5th %ile": 194,
    "25th %ile": 210,
    Mean: 221,
    "75th %ile": 232,
    "95th %ile": 248,
  },
  {
    Grade: 10.6666666666667,
    "5th %ile": 192,
    "25th %ile": 209,
    Mean: 221,
    "75th %ile": 233,
    "95th %ile": 249,
  },
  {
    Grade: 11,
    "5th %ile": 195,
    "25th %ile": 211,
    Mean: 223,
    "75th %ile": 234,
    "95th %ile": 250,
  },
  {
    Grade: 11.3333333333333,
    "5th %ile": 195,
    "25th %ile": 212,
    Mean: 223,
    "75th %ile": 234,
    "95th %ile": 250,
  },
  {
    Grade: 11.6666666666667,
    "5th %ile": 193,
    "25th %ile": 210,
    Mean: 222,
    "75th %ile": 234,
    "95th %ile": 251,
  },
  {
    Grade: 12,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
]

export const mathData: Array<ChartDataPoint> = [
  {
    Grade: "K",
    "95th %ile": 165,
    "75th %ile": 150,
    Mean: 140,
    "25th %ile": 130,
    "5th %ile": 115,
  },
  {
    Grade: 0.333333333333333,
    "95th %ile": 174,
    "75th %ile": 161,
    Mean: 151,
    "25th %ile": 140,
    "5th %ile": 126,
  },
  {
    Grade: 0.666666666666667,
    "95th %ile": 182,
    "75th %ile": 168,
    Mean: 159,
    "25th %ile": 149,
    "5th %ile": 135,
  },
  {
    Grade: 1,
    "95th %ile": 184,
    "75th %ile": 171,
    Mean: 162,
    "25th %ile": 154,
    "5th %ile": 141,
  },
  {
    Grade: 1.33333333333333,
    "95th %ile": 195,
    "75th %ile": 183,
    Mean: 174,
    "25th %ile": 165,
    "5th %ile": 153,
  },
  {
    Grade: 1.66666666666667,
    "95th %ile": 203,
    "75th %ile": 190,
    Mean: 181,
    "25th %ile": 172,
    "5th %ile": 158,
  },
  {
    Grade: 2,
    "95th %ile": 199,
    "75th %ile": 186,
    Mean: 177,
    "25th %ile": 168,
    "5th %ile": 155,
  },
  {
    Grade: 2.33333333333333,
    "95th %ile": 208,
    "75th %ile": 195,
    Mean: 186,
    "25th %ile": 178,
    "5th %ile": 165,
  },
  {
    Grade: 2.66666666666667,
    "95th %ile": 214,
    "75th %ile": 201,
    Mean: 192,
    "25th %ile": 183,
    "5th %ile": 170,
  },
  {
    Grade: 3,
    "95th %ile": 212,
    "75th %ile": 199,
    Mean: 190,
    "25th %ile": 182,
    "5th %ile": 169,
  },
  {
    Grade: 3.33333333333333,
    "95th %ile": 220,
    "75th %ile": 207,
    Mean: 198,
    "25th %ile": 189,
    "5th %ile": 176,
  },
  {
    Grade: 3.66666666666667,
    "95th %ile": 226,
    "75th %ile": 213,
    Mean: 203,
    "25th %ile": 194,
    "5th %ile": 181,
  },
  {
    Grade: 4,
    "95th %ile": 225,
    "75th %ile": 211,
    Mean: 202,
    "25th %ile": 193,
    "5th %ile": 179,
  },
  {
    Grade: 4.33333333333333,
    "95th %ile": 232,
    "75th %ile": 218,
    Mean: 209,
    "25th %ile": 199,
    "5th %ile": 185,
  },
  {
    Grade: 4.66666666666667,
    "95th %ile": 238,
    "75th %ile": 224,
    Mean: 213,
    "25th %ile": 203,
    "5th %ile": 189,
  },
  {
    Grade: 5,
    "95th %ile": 236,
    "75th %ile": 221,
    Mean: 211,
    "25th %ile": 203,
    "5th %ile": 187,
  },
  {
    Grade: 5.33333333333333,
    "95th %ile": 242,
    "75th %ile": 228,
    Mean: 217,
    "25th %ile": 207,
    "5th %ile": 192,
  },
  {
    Grade: 5.66666666666667,
    "95th %ile": 248,
    "75th %ile": 232,
    Mean: 221,
    "25th %ile": 210,
    "5th %ile": 195,
  },
  {
    Grade: 6,
    "95th %ile": 243,
    "75th %ile": 228,
    Mean: 218,
    "25th %ile": 207,
    "5th %ile": 192,
  },
  {
    Grade: 6.33333333333333,
    "95th %ile": 248,
    "75th %ile": 233,
    Mean: 222,
    "25th %ile": 211,
    "5th %ile": 196,
  },
  {
    Grade: 6.66666666666666,
    "95th %ile": 253,
    "75th %ile": 237,
    Mean: 225,
    "25th %ile": 214,
    "5th %ile": 198,
  },
  {
    Grade: 7,
    "95th %ile": 250,
    "75th %ile": 234,
    Mean: 223,
    "25th %ile": 211,
    "5th %ile": 195,
  },
  {
    Grade: 7.33333333333333,
    "95th %ile": 254,
    "75th %ile": 238,
    Mean: 226,
    "25th %ile": 215,
    "5th %ile": 198,
  },
  {
    Grade: 7.66666666666666,
    "95th %ile": 258,
    "75th %ile": 241,
    Mean: 229,
    "25th %ile": 217,
    "5th %ile": 199,
  },
  {
    Grade: 8,
    "95th %ile": 256,
    "75th %ile": 238,
    Mean: 226,
    "25th %ile": 214,
    "5th %ile": 197,
  },
  {
    Grade: 8.33333333333333,
    "95th %ile": 259,
    "75th %ile": 241,
    Mean: 229,
    "25th %ile": 217,
    "5th %ile": 199,
  },
  {
    Grade: 8.66666666666666,
    "95th %ile": 262,
    "75th %ile": 244,
    Mean: 231,
    "25th %ile": 218,
    "5th %ile": 199,
  },
  {
    Grade: 9,
    "95th %ile": 260,
    "75th %ile": 243,
    Mean: 230,
    "25th %ile": 218,
    "5th %ile": 200,
  },
  {
    Grade: 9.33333333333333,
    "95th %ile": 263,
    "75th %ile": 245,
    Mean: 232,
    "25th %ile": 220,
    "5th %ile": 202,
  },
  {
    Grade: 9.66666666666667,
    "95th %ile": 266,
    "75th %ile": 247,
    Mean: 233,
    "25th %ile": 220,
    "5th %ile": 201,
  },
  {
    Grade: 10,
    "95th %ile": 262,
    "75th %ile": 243,
    Mean: 230,
    "25th %ile": 217,
    "5th %ile": 198,
  },
  {
    Grade: 10.3333333333333,
    "95th %ile": 264,
    "75th %ile": 245,
    Mean: 232,
    "25th %ile": 218,
    "5th %ile": 199,
  },
  {
    Grade: 10.6666666666667,
    "95th %ile": 267,
    "75th %ile": 246,
    Mean: 232,
    "25th %ile": 218,
    "5th %ile": 198,
  },
  {
    Grade: 11,
    "95th %ile": 266,
    "75th %ile": 247,
    Mean: 233,
    "25th %ile": 220,
    "5th %ile": 200,
  },
  {
    Grade: 11.3333333333333,
    "95th %ile": 268,
    "75th %ile": 248,
    Mean: 234,
    "25th %ile": 221,
    "5th %ile": 201,
  },
  {
    Grade: 11.6666666666667,
    "95th %ile": 270,
    "75th %ile": 249,
    Mean: 235,
    "25th %ile": 221,
    "5th %ile": 200,
  },
  {
    Grade: 12,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
]

export const languageData = [
  {
    Grade: "K",
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 0.333333333333333,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 0.66666666666666,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 1,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 1.333333333333333,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 1.66666666666666,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 2,
    "95th %ile": 202,
    "75th %ile": 186,
    Mean: 175,
    "25th %ile": 163,
    "5th %ile": 147,
  },
  {
    Grade: 2.33333333333333,
    "95th %ile": 210,
    "75th %ile": 195,
    Mean: 185,
    "25th %ile": 175,
    "5th %ile": 160,
  },
  {
    Grade: 2.66666666666667,
    "95th %ile": 215,
    "75th %ile": 200,
    Mean: 190,
    "25th %ile": 179,
    "5th %ile": 164,
  },
  {
    Grade: 3,
    "95th %ile": 214,
    "75th %ile": 200,
    Mean: 189,
    "25th %ile": 179,
    "5th %ile": 164,
  },
  {
    Grade: 3.33333333333333,
    "95th %ile": 220,
    "75th %ile": 206,
    Mean: 197,
    "25th %ile": 187,
    "5th %ile": 173,
  },
  {
    Grade: 3.66666666666667,
    "95th %ile": 223,
    "75th %ile": 209,
    Mean: 200,
    "25th %ile": 190,
    "5th %ile": 177,
  },
  {
    Grade: 4,
    "95th %ile": 223,
    "75th %ile": 209,
    Mean: 199,
    "25th %ile": 189,
    "5th %ile": 175,
  },
  {
    Grade: 4.33333333333333,
    "95th %ile": 227,
    "75th %ile": 214,
    Mean: 204,
    "25th %ile": 195,
    "5th %ile": 182,
  },
  {
    Grade: 4.66666666666667,
    "95th %ile": 229,
    "75th %ile": 216,
    Mean: 207,
    "25th %ile": 197,
    "5th %ile": 184,
  },
  {
    Grade: 5,
    "95th %ile": 228,
    "75th %ile": 215,
    Mean: 206,
    "25th %ile": 196,
    "5th %ile": 183,
  },
  {
    Grade: 5.33333333333333,
    "95th %ile": 231,
    "75th %ile": 219,
    Mean: 210,
    "25th %ile": 201,
    "5th %ile": 188,
  },
  {
    Grade: 5.66666666666667,
    "95th %ile": 233,
    "75th %ile": 220,
    Mean: 211,
    "25th %ile": 203,
    "5th %ile": 190,
  },
  {
    Grade: 6,
    "95th %ile": 233,
    "75th %ile": 220,
    Mean: 211,
    "25th %ile": 201,
    "5th %ile": 188,
  },
  {
    Grade: 6.33333333333333,
    "95th %ile": 236,
    "75th %ile": 223,
    Mean: 214,
    "25th %ile": 205,
    "5th %ile": 192,
  },
  {
    Grade: 6.66666666666666,
    "95th %ile": 237,
    "75th %ile": 224,
    Mean: 215,
    "25th %ile": 206,
    "5th %ile": 193,
  },
  {
    Grade: 7,
    "95th %ile": 237,
    "75th %ile": 223,
    Mean: 214,
    "25th %ile": 205,
    "5th %ile": 191,
  },
  {
    Grade: 7.33333333333333,
    "95th %ile": 239,
    "75th %ile": 226,
    Mean: 217,
    "25th %ile": 207,
    "5th %ile": 194,
  },
  {
    Grade: 7.66666666666666,
    "95th %ile": 240,
    "75th %ile": 227,
    Mean: 218,
    "25th %ile": 208,
    "5th %ile": 195,
  },
  {
    Grade: 8,
    "95th %ile": 239,
    "75th %ile": 226,
    Mean: 216,
    "25th %ile": 207,
    "5th %ile": 193,
  },
  {
    Grade: 8.33333333333333,
    "95th %ile": 241,
    "75th %ile": 227,
    Mean: 218,
    "25th %ile": 209,
    "5th %ile": 195,
  },
  {
    Grade: 8.66666666666666,
    "95th %ile": 242,
    "75th %ile": 229,
    Mean: 219,
    "25th %ile": 209,
    "5th %ile": 196,
  },
  {
    Grade: 9,
    "95th %ile": 242,
    "75th %ile": 228,
    Mean: 218,
    "25th %ile": 209,
    "5th %ile": 195,
  },
  {
    Grade: 9.33333333333333,
    "95th %ile": 243,
    "75th %ile": 229,
    Mean: 220,
    "25th %ile": 210,
    "5th %ile": 197,
  },
  {
    Grade: 9.66666666666667,
    "95th %ile": 244,
    "75th %ile": 230,
    Mean: 220,
    "25th %ile": 211,
    "5th %ile": 197,
  },
  {
    Grade: 10,
    "95th %ile": 244,
    "75th %ile": 229,
    Mean: 219,
    "25th %ile": 209,
    "5th %ile": 194,
  },
  {
    Grade: 10.3333333333333,
    "95th %ile": 244,
    "75th %ile": 230,
    Mean: 220,
    "25th %ile": 210,
    "5th %ile": 195,
  },
  {
    Grade: 10.6666666666667,
    "95th %ile": 246,
    "75th %ile": 231,
    Mean: 220,
    "25th %ile": 210,
    "5th %ile": 194,
  },
  {
    Grade: 11,
    "95th %ile": 246,
    "75th %ile": 232,
    Mean: 222,
    "25th %ile": 211,
    "5th %ile": 197,
  },
  {
    Grade: 11.3333333333333,
    "95th %ile": 247,
    "75th %ile": 232,
    Mean: 222,
    "25th %ile": 212,
    "5th %ile": 198,
  },
  {
    Grade: 11.6666666666667,
    "95th %ile": 248,
    "75th %ile": 233,
    Mean: 222,
    "25th %ile": 211,
    "5th %ile": 196,
  },
  {
    Grade: 12,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
]

export const scienceData: Array<ChartDataPoint> = [
  {
    Grade: "K",
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: 0.333333333333333,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: 0.666666666666667,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: 1,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: 1.33333333333333,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: 1.66666666666667,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: 2,
    "5th %ile": 156,
    "25th %ile": 169,
    Mean: 178,
    "75th %ile": 187,
    "95th %ile": 200,
  },
  {
    Grade: 2.33333333333333,
    "5th %ile": 164,
    "25th %ile": 176,
    Mean: 185,
    "75th %ile": 193,
    "95th %ile": 205,
  },
  {
    Grade: 2.66666666666667,
    "5th %ile": 167,
    "25th %ile": 179,
    Mean: 188,
    "75th %ile": 196,
    "95th %ile": 208,
  },
  {
    Grade: 3,
    "5th %ile": 168,
    "25th %ile": 180,
    Mean: 187,
    "75th %ile": 195,
    "95th %ile": 207,
  },
  {
    Grade: 3.33333333333333,
    "5th %ile": 175,
    "25th %ile": 185,
    Mean: 193,
    "75th %ile": 200,
    "95th %ile": 211,
  },
  {
    Grade: 3.66666666666667,
    "5th %ile": 177,
    "25th %ile": 188,
    Mean: 195,
    "75th %ile": 203,
    "95th %ile": 214,
  },
  {
    Grade: 4,
    "5th %ile": 176,
    "25th %ile": 187,
    Mean: 195,
    "75th %ile": 202,
    "95th %ile": 213,
  },
  {
    Grade: 4.33333333333333,
    "5th %ile": 181,
    "25th %ile": 191,
    Mean: 199,
    "75th %ile": 206,
    "95th %ile": 216,
  },
  {
    Grade: 4.66666666666667,
    "5th %ile": 183,
    "25th %ile": 194,
    Mean: 201,
    "75th %ile": 208,
    "95th %ile": 219,
  },
  {
    Grade: 5,
    "5th %ile": 182,
    "25th %ile": 193,
    Mean: 200,
    "75th %ile": 208,
    "95th %ile": 218,
  },
  {
    Grade: 5.33333333333333,
    "5th %ile": 186,
    "25th %ile": 196,
    Mean: 204,
    "75th %ile": 211,
    "95th %ile": 221,
  },
  {
    Grade: 5.66666666666667,
    "5th %ile": 188,
    "25th %ile": 198,
    Mean: 206,
    "75th %ile": 213,
    "95th %ile": 224,
  },
  {
    Grade: 6,
    "5th %ile": 185,
    "25th %ile": 197,
    Mean: 204,
    "75th %ile": 212,
    "95th %ile": 223,
  },
  {
    Grade: 6.33333333333333,
    "5th %ile": 188,
    "25th %ile": 199,
    Mean: 207,
    "75th %ile": 215,
    "95th %ile": 226,
  },
  {
    Grade: 6.66666666666667,
    "5th %ile": 189,
    "25th %ile": 201,
    Mean: 209,
    "75th %ile": 217,
    "95th %ile": 228,
  },
  {
    Grade: 7,
    "5th %ile": 188,
    "25th %ile": 199,
    Mean: 207,
    "75th %ile": 215,
    "95th %ile": 227,
  },
  {
    Grade: 7.33333333333333,
    "5th %ile": 190,
    "25th %ile": 201,
    Mean: 209,
    "75th %ile": 217,
    "95th %ile": 229,
  },
  {
    Grade: 7.66666666666667,
    "5th %ile": 191,
    "25th %ile": 203,
    Mean: 211,
    "75th %ile": 219,
    "95th %ile": 231,
  },
  {
    Grade: 8,
    "5th %ile": 190,
    "25th %ile": 202,
    Mean: 210,
    "75th %ile": 219,
    "95th %ile": 230,
  },
  {
    Grade: 8.33333333333333,
    "5th %ile": 192,
    "25th %ile": 204,
    Mean: 212,
    "75th %ile": 221,
    "95th %ile": 232,
  },
  {
    Grade: 8.66666666666667,
    "5th %ile": 193,
    "25th %ile": 205,
    Mean: 214,
    "75th %ile": 222,
    "95th %ile": 234,
  },
  {
    Grade: 9,
    "5th %ile": 191,
    "25th %ile": 204,
    Mean: 212,
    "75th %ile": 221,
    "95th %ile": 234,
  },
  {
    Grade: 9.33333333333333,
    "5th %ile": 193,
    "25th %ile": 205,
    Mean: 214,
    "75th %ile": 223,
    "95th %ile": 235,
  },
  {
    Grade: 9.66666666666667,
    "5th %ile": 193,
    "25th %ile": 206,
    Mean: 215,
    "75th %ile": 224,
    "95th %ile": 237,
  },
  {
    Grade: 10,
    "5th %ile": 191,
    "25th %ile": 204,
    Mean: 213,
    "75th %ile": 223,
    "95th %ile": 236,
  },
  {
    Grade: 10.33333333333333,
    "5th %ile": 192,
    "25th %ile": 205,
    Mean: 214,
    "75th %ile": 224,
    "95th %ile": 237,
  },
  {
    Grade: 10.66666666666667,
    "5th %ile": 192,
    "25th %ile": 205,
    Mean: 215,
    "75th %ile": 225,
    "95th %ile": 239,
  },
  {
    Grade: 11,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 11.33333333333333,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 11.66666666666667,
    "95th %ile": null,
    "75th %ile": null,
    Mean: null,
    "25th %ile": null,
    "5th %ile": null,
  },
  {
    Grade: 12,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
]

export const spanishReadingData: ChartDataPoint[] = [
  {
    Grade: "K",
    "5th %ile": 120,
    "25th %ile": 127,
    Mean: 132,
    "75th %ile": 137,
    "95th %ile": 145,
  },
  {
    Grade: 0.333333333333333,
    "5th %ile": 126,
    "25th %ile": 135,
    Mean: 142,
    "75th %ile": 149,
    "95th %ile": 159,
  },
  {
    Grade: 0.666666666666667,
    "5th %ile": 125,
    "25th %ile": 141,
    Mean: 152,
    "75th %ile": 162,
    "95th %ile": 178,
  },
  {
    Grade: 1,
    "5th %ile": 128,
    "25th %ile": 140,
    Mean: 148,
    "75th %ile": 156,
    "95th %ile": 168,
  },
  {
    Grade: 1.333333333333333,
    "5th %ile": 137,
    "25th %ile": 149,
    Mean: 158,
    "75th %ile": 166,
    "95th %ile": 179,
  },
  {
    Grade: 1.666666666666667,
    "5th %ile": 142,
    "25th %ile": 156,
    Mean: 166,
    "75th %ile": 176,
    "95th %ile": 191,
  },
  {
    Grade: 2,
    "5th %ile": 147,
    "25th %ile": 159,
    Mean: 168,
    "75th %ile": 176,
    "95th %ile": 189,
  },
  {
    Grade: 2.333333333333333,
    "5th %ile": 154,
    "25th %ile": 167,
    Mean: 176,
    "75th %ile": 185,
    "95th %ile": 197,
  },
  {
    Grade: 2.666666666666667,
    "5th %ile": 159,
    "25th %ile": 173,
    Mean: 183,
    "75th %ile": 193,
    "95th %ile": 207,
  },
  {
    Grade: 3,
    "5th %ile": 159,
    "25th %ile": 172,
    Mean: 182,
    "75th %ile": 191,
    "95th %ile": 205,
  },
  {
    Grade: 3.333333333333333,
    "5th %ile": 166,
    "25th %ile": 179,
    Mean: 188,
    "75th %ile": 198,
    "95th %ile": 211,
  },
  {
    Grade: 3.666666666666667,
    "5th %ile": 166,
    "25th %ile": 180,
    Mean: 189,
    "75th %ile": 199,
    "95th %ile": 213,
  },
  {
    Grade: 4,
    "5th %ile": 166,
    "25th %ile": 181,
    Mean: 191,
    "75th %ile": 201,
    "95th %ile": 215,
  },
  {
    Grade: 4.333333333333333,
    "5th %ile": 172,
    "25th %ile": 186,
    Mean: 196,
    "75th %ile": 201,
    "95th %ile": 220,
  },
  {
    Grade: 4.666666666666667,
    "5th %ile": 175,
    "25th %ile": 189,
    Mean: 198,
    "75th %ile": 207,
    "95th %ile": 221,
  },
  {
    Grade: 5,
    "5th %ile": 173,
    "25th %ile": 188,
    Mean: 198,
    "75th %ile": 208,
    "95th %ile": 222,
  },
  {
    Grade: 5.333333333333333,
    "5th %ile": 178,
    "25th %ile": 192,
    Mean: 202,
    "75th %ile": 211,
    "95th %ile": 225,
  },
  {
    Grade: 5.666666666666667,
    "5th %ile": 182,
    "25th %ile": 195,
    Mean: 204,
    "75th %ile": 214,
    "95th %ile": 227,
  },
  {
    Grade: 6,
    "5th %ile": 180,
    "25th %ile": 193,
    Mean: 203,
    "75th %ile": 213,
    "95th %ile": 227,
  },
  {
    Grade: 6.333333333333333,
    "5th %ile": 182,
    "25th %ile": 196,
    Mean: 206,
    "75th %ile": 216,
    "95th %ile": 230,
  },
  {
    Grade: 6.666666666666667,
    "5th %ile": 187,
    "25th %ile": 201,
    Mean: 210,
    "75th %ile": 220,
    "95th %ile": 234,
  },
  {
    Grade: 7,
    "5th %ile": 183,
    "25th %ile": 197,
    Mean: 207,
    "75th %ile": 217,
    "95th %ile": 232,
  },
  {
    Grade: 7.333333333333333,
    "5th %ile": 185,
    "25th %ile": 199,
    Mean: 209,
    "75th %ile": 219,
    "95th %ile": 233,
  },
  {
    Grade: 7.666666666666667,
    "5th %ile": 191,
    "25th %ile": 205,
    Mean: 215,
    "75th %ile": 224,
    "95th %ile": 238,
  },
  {
    Grade: 8,
    "5th %ile": 185,
    "25th %ile": 200,
    Mean: 210,
    "75th %ile": 221,
    "95th %ile": 236,
  },
  {
    Grade: 8.333333333333333,
    "5th %ile": 187,
    "25th %ile": 202,
    Mean: 212,
    "75th %ile": 223,
    "95th %ile": 237,
  },
  {
    Grade: 9,
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
]

export interface ChartOralDataPoint {
  Grade: number | string
  "10th %ile": number | null
  "25th %ile": number | null
  "50th %ile": number | null
  "75th %ile": number | null
  "90th %ile": number | null
  [name: string]: number | string | null
}

export const oralData: Array<ChartOralDataPoint> = [
  {
    Grade: "",
    "10th %ile": null,
    "25th %ile": null,
    "50th %ile": null,
    "75th %ile": null,
    "90th %ile": null,
  },
  {
    Grade: "PK",
    "10th %ile": null,
    "25th %ile": null,
    "50th %ile": null,
    "75th %ile": null,
    "90th %ile": null,
  },
  {
    Grade: "K",
    "10th %ile": null,
    "25th %ile": null,
    "50th %ile": null,
    "75th %ile": null,
    "90th %ile": null,
  },
  {
    Grade: 1,
    "10th %ile": null,
    "25th %ile": null,
    "50th %ile": null,
    "75th %ile": null,
    "90th %ile": null,
  },
  {
    Grade: 1.3,
    "10th %ile": 10,
    "25th %ile": 16,
    "50th %ile": 29,
    "75th %ile": 59,
    "90th %ile": 97,
  },
  {
    Grade: 1.6,
    "10th %ile": 18,
    "25th %ile": 34,
    "50th %ile": 60,
    "75th %ile": 91,
    "90th %ile": 116,
  },
  {
    Grade: 2,
    "10th %ile": 23,
    "25th %ile": 36,
    "50th %ile": 50,
    "75th %ile": 84,
    "90th %ile": 111,
  },
  {
    Grade: 2.3,
    "10th %ile": 35,
    "25th %ile": 59,
    "50th %ile": 84,
    "75th %ile": 109,
    "90th %ile": 131,
  },
  {
    Grade: 2.6,
    "10th %ile": 43,
    "25th %ile": 72,
    "50th %ile": 100,
    "75th %ile": 124,
    "90th %ile": 148,
  },
  {
    Grade: 3,
    "10th %ile": 40,
    "25th %ile": 59,
    "50th %ile": 83,
    "75th %ile": 104,
    "90th %ile": 134,
  },
  {
    Grade: 3.3,
    "10th %ile": 62,
    "25th %ile": 79,
    "50th %ile": 97,
    "75th %ile": 137,
    "90th %ile": 161,
  },
  {
    Grade: 3.6,
    "10th %ile": 63,
    "25th %ile": 91,
    "50th %ile": 112,
    "75th %ile": 139,
    "90th %ile": 166,
  },
  {
    Grade: 4,
    "10th %ile": 60,
    "25th %ile": 75,
    "50th %ile": 94,
    "75th %ile": 125,
    "90th %ile": 153,
  },
  {
    Grade: 4.3,
    "10th %ile": 71,
    "25th %ile": 95,
    "50th %ile": 120,
    "75th %ile": 143,
    "90th %ile": 160,
  },
  {
    Grade: 4.6,
    "10th %ile": 83,
    "25th %ile": 105,
    "50th %ile": 133,
    "75th %ile": 160,
    "90th %ile": 184,
  },
  {
    Grade: 5,
    "10th %ile": 64,
    "25th %ile": 87,
    "50th %ile": 121,
    "75th %ile": 153,
    "90th %ile": 179,
  },
  {
    Grade: 5.3,
    "10th %ile": 84,
    "25th %ile": 109,
    "50th %ile": 133,
    "75th %ile": 160,
    "90th %ile": 183,
  },
  {
    Grade: 5.6,
    "10th %ile": 102,
    "25th %ile": 119,
    "50th %ile": 146,
    "75th %ile": 169,
    "90th %ile": 195,
  },
  {
    Grade: 6,
    "10th %ile": 89,
    "25th %ile": 112,
    "50th %ile": 132,
    "75th %ile": 159,
    "90th %ile": 185,
  },
  {
    Grade: 6.3,
    "10th %ile": 91,
    "25th %ile": 116,
    "50th %ile": 145,
    "75th %ile": 166,
    "90th %ile": 195,
  },
  {
    Grade: 6.6,
    "10th %ile": 91,
    "25th %ile": 122,
    "50th %ile": 146,
    "75th %ile": 173,
    "90th %ile": 204,
  },
]

export const phonologicalAwarenessData: Array<ChartDataPoint> = [
  {
    Grade: "",
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: "PK",
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: "K",
    "5th %ile": 477,
    "25th %ile": 484,
    Mean: 488,
    "75th %ile": 493,
    "95th %ile": 500,
  },
  {
    Grade: 0.3,
    "5th %ile": 481,
    "25th %ile": 489,
    Mean: 494,
    "75th %ile": 499,
    "95th %ile": 507,
  },
  {
    Grade: 0.6,
    "5th %ile": 485,
    "25th %ile": 493,
    Mean: 498,
    "75th %ile": 503,
    "95th %ile": 512,
  },
  {
    Grade: 1,
    "5th %ile": 487,
    "25th %ile": 494,
    Mean: 499,
    "75th %ile": 504,
    "95th %ile": 511,
  },
  {
    Grade: 1.3,
    "5th %ile": 490,
    "25th %ile": 498,
    Mean: 503,
    "75th %ile": 507,
    "95th %ile": 515,
  },
  {
    Grade: 1.6,
    "5th %ile": 492,
    "25th %ile": 499,
    Mean: 504,
    "75th %ile": 509,
    "95th %ile": 517,
  },
  {
    Grade: 2,
    "5th %ile": 491,
    "25th %ile": 498,
    Mean: 502,
    "75th %ile": 507,
    "95th %ile": 513,
  },
  {
    Grade: 2.3,
    "5th %ile": 493,
    "25th %ile": 500,
    Mean: 504,
    "75th %ile": 509,
    "95th %ile": 516,
  },
  {
    Grade: 2.6,
    "5th %ile": 493,
    "25th %ile": 501,
    Mean: 506,
    "75th %ile": 511,
    "95th %ile": 518,
  },
  {
    Grade: 3,
    "5th %ile": 492,
    "25th %ile": 499,
    Mean: 503,
    "75th %ile": 508,
    "95th %ile": 515,
  },
  {
    Grade: 3.3,
    "5th %ile": 494,
    "25th %ile": 501,
    Mean: 505,
    "75th %ile": 510,
    "95th %ile": 517,
  },
  {
    Grade: 3.6,
    "5th %ile": 493,
    "25th %ile": 501,
    Mean: 506,
    "75th %ile": 511,
    "95th %ile": 519,
  },
]

export const phonicsWordRecognitionData: Array<ChartDataPoint> = [
  {
    Grade: "",
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: "PK",
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: "K",
    "5th %ile": 471,
    "25th %ile": 482,
    Mean: 487,
    "75th %ile": 492,
    "95th %ile": 498,
  },
  {
    Grade: 0.3,
    "5th %ile": 481,
    "25th %ile": 489,
    Mean: 494,
    "75th %ile": 499,
    "95th %ile": 507,
  },
  {
    Grade: 0.6,
    "5th %ile": 485,
    "25th %ile": 493,
    Mean: 499,
    "75th %ile": 504,
    "95th %ile": 512,
  },
  {
    Grade: 1,
    "5th %ile": 487,
    "25th %ile": 494,
    Mean: 499,
    "75th %ile": 504,
    "95th %ile": 512,
  },
  {
    Grade: 1.3,
    "5th %ile": 491,
    "25th %ile": 498,
    Mean: 503,
    "75th %ile": 508,
    "95th %ile": 516,
  },
  {
    Grade: 1.6,
    "5th %ile": 493,
    "25th %ile": 501,
    Mean: 506,
    "75th %ile": 511,
    "95th %ile": 519,
  },
  {
    Grade: 2,
    "5th %ile": 492,
    "25th %ile": 499,
    Mean: 504,
    "75th %ile": 509,
    "95th %ile": 516,
  },
  {
    Grade: 2.3,
    "5th %ile": 494,
    "25th %ile": 502,
    Mean: 507,
    "75th %ile": 512,
    "95th %ile": 519,
  },
  {
    Grade: 2.6,
    "5th %ile": 496,
    "25th %ile": 503,
    Mean: 508,
    "75th %ile": 513,
    "95th %ile": 521,
  },
  {
    Grade: 3,
    "5th %ile": 495,
    "25th %ile": 501,
    Mean: 506,
    "75th %ile": 511,
    "95th %ile": 518,
  },
  {
    Grade: 3.3,
    "5th %ile": 495,
    "25th %ile": 503,
    Mean: 508,
    "75th %ile": 513,
    "95th %ile": 520,
  },
  {
    Grade: 3.6,
    "5th %ile": 496,
    "25th %ile": 503,
    Mean: 509,
    "75th %ile": 514,
    "95th %ile": 521,
  },
]

export const languageComprehensionData: Array<ChartDataPoint> = [
  {
    Grade: "",
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: "PK",
    "5th %ile": null,
    "25th %ile": null,
    Mean: null,
    "75th %ile": null,
    "95th %ile": null,
  },
  {
    Grade: "K",
    "5th %ile": 480,
    "25th %ile": 487,
    Mean: 491,
    "75th %ile": 495,
    "95th %ile": 502,
  },
  {
    Grade: 0.3,
    "5th %ile": 482,
    "25th %ile": 489,
    Mean: 494,
    "75th %ile": 499,
    "95th %ile": 506,
  },
  {
    Grade: 0.6,
    "5th %ile": 485,
    "25th %ile": 492,
    Mean: 497,
    "75th %ile": 502,
    "95th %ile": 509,
  },
  {
    Grade: 1,
    "5th %ile": 485,
    "25th %ile": 492,
    Mean: 497,
    "75th %ile": 502,
    "95th %ile": 509,
  },
  {
    Grade: 1.3,
    "5th %ile": 488,
    "25th %ile": 495,
    Mean: 500,
    "75th %ile": 505,
    "95th %ile": 512,
  },
  {
    Grade: 1.6,
    "5th %ile": 490,
    "25th %ile": 497,
    Mean: 502,
    "75th %ile": 507,
    "95th %ile": 514,
  },
  {
    Grade: 2,
    "5th %ile": 489,
    "25th %ile": 496,
    Mean: 501,
    "75th %ile": 506,
    "95th %ile": 512,
  },
  {
    Grade: 2.3,
    "5th %ile": 490,
    "25th %ile": 497,
    Mean: 502,
    "75th %ile": 507,
    "95th %ile": 514,
  },
  {
    Grade: 2.6,
    "5th %ile": 491,
    "25th %ile": 498,
    Mean: 504,
    "75th %ile": 509,
    "95th %ile": 516,
  },
  {
    Grade: 3,
    "5th %ile": 490,
    "25th %ile": 497,
    Mean: 502,
    "75th %ile": 507,
    "95th %ile": 515,
  },
  {
    Grade: 3.3,
    "5th %ile": 491,
    "25th %ile": 498,
    Mean: 503,
    "75th %ile": 508,
    "95th %ile": 516,
  },
  {
    Grade: 3.6,
    "5th %ile": 490,
    "25th %ile": 498,
    Mean: 504,
    "75th %ile": 509,
    "95th %ile": 517,
  },
]
